import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { getConferenceName } from '../../../base/conference/functions';
import Icon from '../../../base/icons/components/Icon';
import { IconShieldLock } from '../../../base/icons/svg';
import Tooltip from '../../../base/tooltip/components/Tooltip';
import { getBrandServiceName } from '../../../utils/brandDomainUtils';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            ...theme.typography.bodyLongRegular,
            color: theme.palette.conferenceSubjectText,
            padding: '2px 16px',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            maxWidth: '324px',
            boxSizing: 'border-box',
            height: '28px',
            borderRadius: `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`,
            marginLeft: '2px',
            '@media (max-width: 300px)': {
                display: 'none'
            }
        },
        content: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        dataCenterIcon: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            boxSizing: 'border-box',
            height: '28px',
            width: '28px',
            borderRadius: `${theme.shape.borderRadius}px`,
            marginRight: '2px',
            '@media (max-width: 300px)': {
                display: 'none'
            }
        }
    };
});
/**
 * Label for the conference name.
 *
 * @returns {ReactElement}
 */
const SubjectText = () => {
    const subject = codiceStanzaPerVisualizzazione(useSelector(getConferenceName));
    const { classes } = useStyles();
    const { t } = useTranslation();
    return (React.createElement("div", { style: { display: "flex", justifyContent: "center" } },
        React.createElement(Tooltip, { content: t('notify.dataCenterDescription', { serviceName: getBrandServiceName() }), position: 'bottom' },
            React.createElement("div", { className: classes.dataCenterIcon },
                React.createElement(Icon, { color: '#fff', size: 16, src: IconShieldLock }))),
        React.createElement(Tooltip, { content: subject, position: 'bottom' },
            React.createElement("div", { className: classes.container },
                React.createElement("div", { className: clsx('subject-text--content', classes.content) }, subject)))));
};
function codiceStanzaPerVisualizzazione(roomName) {
    if (roomName.length == 10) {
        return (roomName.substring(0, 3) +
            " - " +
            roomName.substring(3, 7) +
            " - " +
            roomName.substring(7));
    }
    else {
        return roomName;
    }
}
export default SubjectText;
